export default "__VITE_ASSET__CfGa5RcI__"